var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section",attrs:{"id":"simulation-section"}},[_c('section-title',{attrs:{"text":_vm.title}}),_c('article',{staticClass:"article",attrs:{"id":"simulation"}},_vm._l((_vm.content.simulation),function(item,index){return _c('simulation-box',{key:index,attrs:{"simulation":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }